import React from 'react';
import { MAX_COLUMNS } from '../../data/constants';
import { getPrincipaleOPrimoGruppo } from '../../data/utils';
import TournamentColumnBets from './TournamentColumnBets';
import TournamentLiveBets from './TournamentLiveBets';
import TournamentBets from './TournamentBets';

function PrematchTournamentMatch(props) {
    const match = props.match;
    
    if (props.isLive) {
        return <TournamentLiveBets match={match} openMatch={props.openMatch} />;
    }
    
    if (props.aggregata != null && match.betsById.size === 0 && !props.betBuilder) {
        const aggregata = props.aggregata ? match.gruppoById[props.aggregata] : getPrincipaleOPrimoGruppo(match.gruppiScommessa);
        if (aggregata.scommesse.length > 1) {
            let nOdds = 0;
            aggregata.scommesse.forEach(bet => {
                nOdds += bet.odds.length;
            });
            if (nOdds > MAX_COLUMNS) {
                return <TournamentColumnBets match={match} agg={aggregata} showTournamentDesc={props.showTournamentDesc} openMatch={props.openMatch} />;
            }
        }
    }

    return <TournamentBets betBuilder={props.betBuilder} match={match} agg={props.aggregata} highlight={props.highlight} showTournamentDesc={props.showTournamentDesc} openMatch={props.openMatch} isLastMinute={props.isLastMinute} />;
}

export default PrematchTournamentMatch;
